const communityContants = Object.freeze({
  COMMUNITY_FEATURE_TYPES: {
    COURSE: 'course',
    EVENT: 'event',
  },
});

module.exports = communityContants;
